import React, { useCallback, useMemo } from "react";
import { useDispatch, useSelector } from "react-redux";
import PropTypes from "prop-types";
import { RescheduleAction } from "~/components/ActionElements/index.jsx";
import { clearRescheduleSimulation } from "~/store/actions/actions.taskDependencies.jsx";
import { fetchTaskRescheduleSimulation } from "~/store/actions/actions.tasks.jsx";
import { getRawConfigOption } from "~/store/selectors/selector.configOptions.jsx";
import { getIsSimulationChanged, getSimulationTasks } from "~/store/selectors/selector.taskDependencies.jsx";

export const TaskRescheduleAction = ({ id, action, children }) => {
  const dispatch = useDispatch();
  const autoReschedule = useSelector((state) => getRawConfigOption(state, "auto_reschedule_enabled"));
  const simulation = useSelector((state) => getSimulationTasks(state));
  const isSimulationChanged = useSelector((state) => getIsSimulationChanged(state));

  const affectedTasks = useMemo(() => {
    if (simulation) {
      return Object.values(simulation).filter((t) => "old" in t && "new" in t);
    }
    return [];
  }, [simulation]);

  const splitTask = useMemo(() => {
    if (simulation) {
      return Object.values(simulation).find((t) => "is_split" in t);
    }
    return undefined;
  }, [simulation]);

  const getSimulation = useCallback(
    (startOn, dueOn) => {
      if (autoReschedule && typeof dueOn === `number` && dueOn > 0 && id > 0) {
        return dispatch(fetchTaskRescheduleSimulation(id, { due_on: dueOn, start_on: startOn }));
      }
    },
    [autoReschedule, dispatch, id]
  );

  const clearSimulation = useCallback(() => {
    return dispatch(clearRescheduleSimulation());
  }, [dispatch]);

  return (
    <RescheduleAction
      action={action}
      onCancel={clearSimulation}
      getSimulation={getSimulation}
      simulation={affectedTasks}
      isSimulationChanged={isSimulationChanged}
      splitTask={splitTask}
    >
      {children}
    </RescheduleAction>
  );
};

TaskRescheduleAction.propTypes = {
  id: PropTypes.number,
  action: PropTypes.string,
  children: PropTypes.element.isRequired,
};
